/* eslint-disable react/prop-types */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/button-has-type */
/* eslint-disable linebreak-style */
import React from 'react';
import { observer } from 'mobx-react-lite';

const ButtonClose = ({ handleClose }) => (
    <button
        className="mt-[24px] flex items-center justify-center gap-4 w-10 h-10 bg-[#F1F3F8] p-3 uppercase text-[18px] text-[#3A3A3A] font-bold tracking-[.08em]"
        onClick={handleClose}
    >
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2910_8922)">
                <path
                    d="M15.9294 0.571289L1.07227 15.4284"
                    stroke="#3A3A3A"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M1.07227 0.571289L15.9294 15.4284"
                    stroke="#3A3A3A"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2910_8922">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
       
    </button>
);

export default ButtonClose;
